export function useScreen() {
  return useBreakpoints({
    sm: 760,
    md: 992,
    lg: 1400,
    xl: 1600,
  })
}
